interface Position {  
    currentChapterId: number;
    currentPageId: number;
}

export default class History {
    public static jumpHistory:Array<Position> = [];
}



// WEBPACK FOOTER //
// ./src/objects/History.ts